module.exports = __webpack_public_path__ + "static/media/internetarchive.f3241ece.svg";